type PaymentSummary = {
  type?: string | null
  status?: string | null
}

export type PurchaseOrderAccessRegistration = {
  paymentType?: string | null
  paymentStatus?: string | null
  payments?: PaymentSummary[]
}

const READY_STATUSES = new Set(['received', 'invoiced'])

const normalize = (value?: string | null): string => value?.trim().toLowerCase() || ''
const normalizeType = (value?: string | null): string => normalize(value).replace(/[^a-z0-9]/g, '')
const isPOType = (value?: string | null): boolean => {
  const type = normalizeType(value)
  return type === 'po' || type === 'purchaseorder'
}

export const isPurchaseOrderRegistration = (registration: PurchaseOrderAccessRegistration): boolean =>
  isPOType(registration.paymentType) ||
  Boolean(registration.payments?.some(payment => isPOType(payment.type)))

export const canAccessRegistrationByPurchaseOrder = (
  registration: PurchaseOrderAccessRegistration,
): boolean => {
  // This is a participant-facing gate only. The launch/check-in APIs must enforce
  // the same rule server-side and must not treat this UI decision as authorization.
  if (!isPurchaseOrderRegistration(registration)) return true

  const poStatuses = registration.payments
    ?.filter(payment => isPOType(payment.type))
    .map(payment => normalize(payment.status))
    .filter(Boolean) ?? []

  if (poStatuses.length > 0) {
    return poStatuses.some(status => READY_STATUSES.has(status))
  }

  return READY_STATUSES.has(normalize(registration.paymentStatus))
}

export const hasPendingPurchaseOrder = (registration: PurchaseOrderAccessRegistration): boolean =>
  isPurchaseOrderRegistration(registration) && !canAccessRegistrationByPurchaseOrder(registration)
